/**
 * CSS Peeper — CSS / asset inspector
 *
 * Every web-accessible resource and every content-script file is build-hashed
 * (`inspector.dbaebc82.css`, `csspeeper-inspector-tools.eb9765a1.js`), so the names
 * rotate each release and a fixed resource probe would break — the same trap as Apollo.
 *
 * But its content script mounts a UI container on load, and that element is stably
 * named: `<plasmo-csui id="plasmo-inspector">`. Found with
 * `tooling/probe-interactions.js` on a plain page with no user action. `plasmo-csui` is
 * the Plasmo framework's shadow-host tag (shared by any Plasmo-built extension), but the
 * id `plasmo-inspector` is derived from CSS Peeper's own "inspector" content script, so
 * the tag+id together identify CSS Peeper rather than merely "a Plasmo extension".
 *
 * Behavioural, so it only fires while the content script is active; and the weight is
 * held below a resource probe because the Plasmo prefix is framework- rather than
 * vendor-namespaced.
 *
 * Observed on version 1.2.2.
 */

import { probeSelector } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'mbnbehikldjhnfehhnaidhjhoofhpehk';

export const cssPeeper: ExtensionDefinition = {
  id: ID,
  name: 'CSS Peeper',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 400_000,
  notes:
    'All resources and content scripts are build-hashed, so resource probing is not ' +
    'durable. Detected instead by the mounted UI element plasmo-csui#plasmo-inspector, ' +
    'whose id is CSS Peeper-specific. Behavioural, framework-prefixed, so weighted below 1.',
  signals: [
    {
      id: 'dom-plasmo-inspector',
      kind: 'dom',
      description:
        'Look for plasmo-csui#plasmo-inspector — the shadow-host container CSS Peeper ' +
        'mounts on load. The id is derived from its own "inspector" content script, so ' +
        'the tag+id identify CSS Peeper rather than any Plasmo extension.',
      weight: 0.7,
      run: () => probeSelector('plasmo-csui#plasmo-inspector', { timeoutMs: 2500 }),
    },
  ],
};
